// extracted by mini-css-extract-plugin
export default {"container":"Signals_container__yZ5lz","title":"Signals_title__yZg4v"};